import { c as _c } from "react/compiler-runtime";
import React from 'react';
import type { AmplienceImage, AmplienceLinkType, CampaignSliderCardVariant } from '@/types/amplience';
import { AmplienceResponsiveImage } from '@/components/ResponsiveImage/AmplienceResponsiveImage';
import AmplienceLink from '../Common/AmplienceLink';
const IMAGE_WIDTHS = [200, 300, 400, 500];
export type CampaignCardProps = {
  image: AmplienceImage;
  linkUrl: AmplienceLinkType;
  title: string;
  subtitle?: string;
  textColor?: string;
  cardVariant?: CampaignSliderCardVariant;
  isLazyLoadingOff?: boolean;
};
const CampaignCard: React.FC<CampaignCardProps> = t0 => {
  const $ = _c(21);
  const {
    image,
    linkUrl,
    title,
    subtitle,
    textColor: t1,
    cardVariant,
    isLazyLoadingOff
  } = t0;
  const textColor = t1 === undefined ? "text-black" : t1;
  let t2;
  if ($[0] !== image.image) {
    t2 = {
      src: image.image,
      sizes: "(min-width: 768px) 25vw, (min-width: 1024) 15vw, 40vw",
      widths: IMAGE_WIDTHS
    };
    $[0] = image.image;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = image.altText ?? "";
  const t4 = isLazyLoadingOff ? "eager" : "lazy";
  let t5;
  if ($[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
    t5 = <AmplienceResponsiveImage source={t2} alt={t3} loading={t4} />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== cardVariant || $[7] !== subtitle || $[8] !== title) {
    t6 = cardVariant === "titleOnImage" && <div className="absolute inset-x-0 bottom-0 z-10 flex h-full flex-col justify-end bg-gradient-to-b from-black/0 via-black/20 to-black/60 p-4"><h2 className="text-sm font-bold text-white md:text-base xl:text-lg">{title}</h2>{subtitle && <p className="text-sm text-white md:text-base">{subtitle}</p>}</div>;
    $[6] = cardVariant;
    $[7] = subtitle;
    $[8] = title;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className="relative flex aspect-3/4 size-full items-center justify-center overflow-hidden md:aspect-[2/3]">{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== cardVariant || $[14] !== textColor || $[15] !== title) {
    t8 = cardVariant === "default" && <div className="flex flex-1 flex-col"><h2 className={`truncate text-center text-sm font-medium ${textColor}`}>{title}</h2></div>;
    $[13] = cardVariant;
    $[14] = textColor;
    $[15] = title;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== linkUrl || $[18] !== t7 || $[19] !== t8) {
    t9 = <AmplienceLink link={linkUrl} className="flex flex-col gap-1">{t7}{t8}</AmplienceLink>;
    $[17] = linkUrl;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
export default CampaignCard;